export default __webpack_public_path__ + "static/superhuman-ai-018aecea79ae586de22051f86a42d234.png";